import {
  COMMAND_EXECUTION_ERROR,
  COMMAND_VALIDATION_ERROR,
  TASKS_COMMAND_EXECUTION_ERROR,
  COMMAND_EXECUTION_WARNING
} from "actions/eventTypes";

export const errorEvents = [COMMAND_EXECUTION_ERROR, COMMAND_VALIDATION_ERROR, TASKS_COMMAND_EXECUTION_ERROR];

export const warningEvents = [COMMAND_EXECUTION_WARNING];
